import { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const SECTIONS = [
  {
    key: "home",
    label: "Home",
    fields: [
      { k: "hero_title", l: "Título hero", type: "text" },
      { k: "hero_subtitle", l: "Subtítulo hero", type: "textarea" },
      { k: "hero_cta", l: "Texto CTA hero", type: "text" },
      { k: "intro_title", l: "Título bloque identidad", type: "text" },
      { k: "intro_body", l: "Texto identidad", type: "textarea" },
      { k: "mimosa_title", l: "Título Mimosa", type: "text" },
      { k: "mimosa_kicker", l: "Subtítulo Mimosa", type: "text" },
      { k: "mimosa_body", l: "Texto Mimosa", type: "textarea" },
    ],
  },
  {
    key: "carta_intro",
    label: "Carta",
    fields: [
      { k: "title", l: "Título de carta", type: "text" },
      { k: "subtitle", l: "Subtítulo de carta", type: "textarea" },
    ],
  },
  { key: "horarios", label: "Horarios", fields: [{ k: "body", l: "Texto de horarios", type: "textarea" }] },
  {
    key: "ubicacion",
    label: "Ubicación",
    fields: [
      { k: "title", l: "Título de ubicación", type: "text" },
      { k: "body", l: "Descripción de ubicación", type: "textarea" },
      { k: "map_embed", l: "URL embed Google Maps", type: "text" },
    ],
  },
  { key: "convivencia", label: "Convivencia", fields: [{ k: "body", l: "Normas", type: "textarea" }] },
  { key: "afiliacion", label: "Afiliación", fields: [{ k: "body", l: "Texto afiliación", type: "textarea" }] },
  { key: "programa_intro", label: "Intro Programa", fields: [{ k: "body", l: "Intro programa", type: "textarea" }] },
];

export default function AdminContenido() {
  const [active, setActive] = useState("home");
  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/content/${active}`).then((r) => setData(r.data.data || {}));
  }, [active]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/content/${active}`, { data });
      toast.success("Guardado");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const section = SECTIONS.find((s) => s.key === active);

  return (
    <div className="space-y-6" data-testid="admin-contenido">
      <header>
        <h1 className="font-display font-black text-3xl">Contenido</h1>
        <p className="text-muted-foreground">Edita los textos principales de la web.</p>
      </header>

      <div className="flex gap-2 flex-wrap">
        {SECTIONS.map((s) => (
          <button
            key={s.key}
            onClick={() => setActive(s.key)}
            data-testid={`content-tab-${s.key}`}
            className={`px-3 py-2 rounded-full text-sm font-medium border transition ${
              active === s.key ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-accent"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-border p-6 space-y-4">
        {section.fields.map((f) => (
          <div key={f.k}>
            <label className="block text-sm font-bold mb-1">{f.l}</label>
            {f.type === "textarea" ? (
              <textarea
                rows={5}
                value={data[f.k] || ""}
                onChange={(e) => setData((d) => ({ ...d, [f.k]: e.target.value }))}
                className="w-full rounded-xl border border-border bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-ring"
                data-testid={`content-field-${f.k}`}
              />
            ) : (
              <input
                type="text"
                value={data[f.k] || ""}
                onChange={(e) => setData((d) => ({ ...d, [f.k]: e.target.value }))}
                className="w-full rounded-xl border border-border bg-white px-4 py-2 focus:outline-none focus:ring-2 focus:ring-ring"
                data-testid={`content-field-${f.k}`}
              />
            )}
          </div>
        ))}
        <button
          onClick={save}
          disabled={saving}
          className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 rounded-full font-bold hover:brightness-110 disabled:opacity-60"
          data-testid="content-save-btn"
        >
          <Save size={16} />
          {saving ? "Guardando…" : "Guardar"}
        </button>
      </div>
    </div>
  );
}
